<template>
  <div>
    <cookie-banner
      v-if="isBannerVisible"
      v-on:settingsSet="checkBanner()"
      v-on:forceRerender="forceRerender"
      :banner-id="bannerId"
      :cookie-config="cookieConfig"
      :translation-path="translationPath"
      :privacy-content-path="privacyContentPath"
      :inline-styles="inlineStyles"
      :lang="lang"
      :logo="logo"
      :settings="settings"
      :key="rerenderKey"
    />
    <button class="[ c-cookie-banner__button  c-cookie-banner__button--primary ]"
            v-if="isButtonVisible"
            @click="checkBanner()">
      {{ $t('general.button.settings') }}
    </button>
  </div>
</template>

<script>
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import CookieBanner from './components/CookieBanner/CookieBanner'
import LocaleRepository from './repositories/LocaleRepository'
import LocalStorageService from './services/LocalStorageService'
import cssVars from 'css-vars-ponyfill'
Vue.use(VueI18n)

export default {
  name: 'App',
  props: {
    cookieConfig: { type: String, default: './config/cookie-data.json' },
    lang: { type: String, default: 'de' },
    logo: String,
    bannerId: { type: String, default: 'nsd-cookie-banner' },
    inlineStyles: { type: String },
    translationPath: String,
    privacyContentPath: { type: String, default: './templates/test.html' },
    editable: { type: Boolean, default: true }
  },
  i18n: new VueI18n({
    fallbackLocale: 'de',
    messages: LocaleRepository.loadLocaleMessages()
  }),
  components: {
    CookieBanner: CookieBanner
  },
  mounted: function () {
    this.$i18n.locale = this.lang
    this.checkSettings()
    cssVars({
      variables: this.inlineStyles ? JSON.parse(this.inlineStyles) : {}
    })
  },
  data: function () {
    return {
      bannerVisible: true,
      buttonVisible: false,
      settings: {},
      rerenderKey: 0
    }
  },
  computed: {
    isBannerVisible: function () {
      return this.bannerVisible
    },
    isButtonVisible: function () {
      return this.editable ? this.buttonVisible : false
    }
  },
  methods: {
    toggleBanner: function () {
      this.bannerVisible = !this.bannerVisible
    },
    toggleButton: function () {
      this.buttonVisible = !this.buttonVisible
    },
    checkBanner: function () {
      this.toggleBanner()
      this.toggleButton()
    },
    checkSettings: function () {
      this.settings = LocalStorageService.getCookieSettings()

      if (this.settings !== null) {
        this.bannerVisible = false
        this.buttonVisible = true
      }
    },
    forceRerender: function (updatedSettings) {
      this.settings = updatedSettings
      this.rerenderKey += 1
    }
  }
}
</script>

<style scoped>
  /* local styles */
  @import "external_assets/styles.css";
</style>
